import { render, staticRenderFns } from "./mdf-registered-deals-widget.vue?vue&type=template&id=cdbf6f90&"
import script from "./mdf-registered-deals-widget.vue?vue&type=script&lang=js&"
export * from "./mdf-registered-deals-widget.vue?vue&type=script&lang=js&"
import style0 from "./mdf-registered-deals-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports